import {detail} from "@mc/mc-legacy";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";

export const GROUP_MENU_CONFIG = "groupMenuConfig";

export function fetchIfNeeded() {
  return (dispatch) => {
    dispatch(detail.DetailActions.fetchIfNeeded(GROUP_MENU_CONFIG, 0, () => SignRequestInternalApi.getRequestConfig()));
  };
}

export function invalidate() {
  return (dispatch) => {
    dispatch(detail.DetailActions.invalidate(GROUP_MENU_CONFIG, 0));
  };
}
